<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 基础设置 > 养生方案
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index, item.id)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line" label="养生对应体质" style="margin-left: 10px;">
								<el-select v-model="searchData.result" placeholder="请选择">
									<el-option value="">请选择</el-option>
									<el-option v-for="item in constitutionOptions" :key="item.id" :trit="item.trit"
										:label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large" @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button>
								<el-button size="large" class="addBtn" @click="add">新增</el-button>
								<el-button size="large" class="searchBtn" @click="searchPluse">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%" :data="tableListData">
							<el-table-column align="center" label="序号" prop="seq" width="80"></el-table-column>
							<el-table-column align="center" label="养生方案名" prop="name"></el-table-column>
							<el-table-column align="center" label="养生对应体质" prop="physique.name"></el-table-column>
							<el-table-column align="center" label="操作" width="100">
								<template #default="{row}">
									<span class="editor" @click="edit(row)">编辑</span>
									<span class="del" @click="del(row)">删除</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right" style="margin-right: 0;">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" layout="prev, pager, next, jumper"
										:total="total" :page-size="10"></el-pagination>
								</div>
								<div class="data">
									共 <span>{{ pages }}</span>页/ <span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增养生方案' : '编辑养生方案'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="110px">
						<div class="item">
							<!-- 养生方案 + 体质 -->
							<div class="line">
								<div class="dialog-tit">
									<span class="border"></span>
									<span>养生方案</span>
								</div>
								<el-form-item label="养生方案" prop="healthPlan">
									<el-input class="longInput" placeholder="请输入养生方案" v-model="addUserForm.healthPlan"></el-input>
								</el-form-item>
								<el-form-item class="el-form-item-line" prop="constitution" label="对应养生体质">
									<el-select :disabled="addOrEdit == 'edit'" v-model="addUserForm.constitution" placeholder="请选择">
										<el-option v-for="item in constitutionOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
									</el-select>
								</el-form-item>
							</div>

							<!-- 配置驱动渲染：所有推荐分组（含商城商品） -->
							<RecommendGroup
								v-for="cfg in renderedTypes"
								:key="cfg.frontKey"
								:config="cfg"
								:groups="addUserForm[cfg.frontKey]"
								@update:groups="(val) => (addUserForm[cfg.frontKey] = val)"
								:source-data="sourceDataMap[cfg.sourceDataKey] || []"
								:form="addUserForm"
								@select="handleGroupSelect"
								@delete="handleGroupDelete"
								@update-text="handleTextFieldUpdate"
							/>
						</div>
					</el-form>
				</div>
				<template class="dialog-footer" #footer>
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
				</template>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import RecommendGroup from './RecommendGroup.vue';
import {
	RECOMMEND_TYPES,
	buildEmptyForm,
	buildFormRules,
	toSubmitPayload,
	fromDetailResponse,
} from './healthPlanConfig.js';

export default {
	components: { RecommendGroup },
	data() {
		return {
			tableListData: [],
			role: '',
			tabList: [
				{ id: 0, name: '舌面释义' },
				{ id: 1, name: '报告结果' },
				{ id: 2, name: '规则设置' },
				{ id: 3, name: '养生方案' },
				{ id: 4, name: '版本管理' },
			],
			resultOptions: [
				{ value: '主要', label: '主要' },
				{ value: '次要', label: '次要' },
			],
			currentTabIndex: 3,
			searchData: { result: '' },
			currentPage: 1,
			totalPage: 1,
			total: 0,
			pages: 0,
			addUserFlag: false,
			addUserForm: buildEmptyForm(),
			rules: buildFormRules(),
			dietTypeOptions: [
				{ label: '菜肴', value: '菜肴' },
				{ label: '粥食', value: '粥食' },
				{ label: '汤羹', value: '汤羹' },
			],
			addOrEdit: '',
			// 候选数据源（autocomplete 使用），由 created 钩子加载
			acupointListData: [],
			dietDishListData: [],
			porridgeListData: [],
			dietSugSoupData: [],
			dietSugTeaData: [],
			medicinalFoodListData: [],
			healthFoodListData: [],
			bjcExerciseListData: [],
			ctgfExerciseListData: [],
			sportExerciseListData: [],
			constitutionOptions: [],
		};
	},
	computed: {
		// HP3：mallProduct 走 ProductSelectorDialog，全部 RECOMMEND_TYPES 一起渲染
		renderedTypes() {
			return RECOMMEND_TYPES;
		},
		// 把 sourceData 集中映射，方便 template v-for 访问
		sourceDataMap() {
			return {
				acupointListData: this.acupointListData,
				dietDishListData: this.dietDishListData,
				porridgeListData: this.porridgeListData,
				dietSugSoupData: this.dietSugSoupData,
				dietSugTeaData: this.dietSugTeaData,
				medicinalFoodListData: this.medicinalFoodListData,
				healthFoodListData: this.healthFoodListData,
				bjcExerciseListData: this.bjcExerciseListData,
				ctgfExerciseListData: this.ctgfExerciseListData,
				sportExerciseListData: this.sportExerciseListData,
			};
		},
	},

	methods: {
		// ---------- 路由 / 列表 / CRUD 主流程 ----------
		goOther(index) {
			this.currentTabIndex = index;
			const routes = [
				'/basicSetting/tongueInterpretation',
				'/basicSetting/reportResult',
				'/basicSetting/ruleSetting',
				'/basicSetting/healthPlan',
				'/basicSetting/versionManagement',
			];
			if (routes[index]) this.$router.push({ path: routes[index] });
		},
		searchPluse() { this.getPlanList(0); },
		reset() {
			this.searchData.result = '';
			this.searchPluse();
		},
		add() {
			this.addUserFlag = true;
			this.addOrEdit = 'add';
			this.addUserForm = buildEmptyForm();
			this.$nextTick(() => {
				this.$refs.addUserForm.clearValidate();
			});
		},
		edit(item) {
			this.addOrEdit = 'edit';
			this.getDetail(item.id);
		},
		getDetail(id) {
			this.$applicationJson('/business/baseHealthPlan/detail', { id })
				.then((res) => {
					if (res.data.code !== 0) return;
					this.addUserForm = fromDetailResponse(res.data.data);
					this.addUserFlag = true;
					this.addOrEdit = 'edit';
					this.$nextTick(() => {
						this.$refs.addUserForm.clearValidate();
					});
				})
				.catch(() => this.$message.error('网络异常'));
		},
		del(item) {
			this.$confirm('此操作将删除该条记录, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(() => this.delConstitute(item.id)).catch(() => {});
		},
		delConstitute(id) {
			this.$applicationJson('/business/baseHealthPlan/delete', { ids: [id] })
				.then((res) => {
					if (res.data.code === 0) {
						this.$message({ type: 'success', message: '删除成功!' });
						this.getPlanList(0);
					}
				})
				.catch(() => this.$message.error('网络异常'));
		},
		cancelPatient() { this.addUserFlag = false; },
		addPatient(formName) {
			this.$refs[formName].validate((valid) => {
				if (!valid) return false;
				if (this.addOrEdit === 'add') this.addUserInfo();
				if (this.addOrEdit === 'edit') this.editUserInfo();
				this.currentPage = 0;
			});
		},
		addUserInfo() {
			this.$applicationJson('/business/baseHealthPlan/add', toSubmitPayload(this.addUserForm, false))
				.then((res) => {
					if (res.data.code === 0) this.addUserFlag = false;
					this.getPlanList(0);
				})
				.catch(() => this.$message.error('网络异常'));
		},
		editUserInfo() {
			this.$applicationJson('/business/baseHealthPlan/edit', toSubmitPayload(this.addUserForm, true))
				.then((res) => {
					if (res.data.code === 0) this.addUserFlag = false;
					this.getPlanList(0);
				})
				.catch(() => this.$message.error('网络异常'));
		},

		// ---------- 候选数据加载 ----------
		getPlanList(currentPage) {
			this.$applicationJson('/business/baseHealthPlan/paging', {
				current: currentPage,
				orderBy: '',
				params: { physiqueId: this.searchData.result },
				size: 10,
			})
				.then((res) => {
					if (res.data.code !== 0) return;
					this.tableListData = res.data.data.records;
					for (let i = 0; i < this.tableListData.length; i++) {
						this.tableListData[i].seq = Number(i) + 1;
					}
					this.total = res.data.data.total;
					this.pages = res.data.data.pages;
				})
				.catch(() => this.$message.error('网络异常'));
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getPlanList(this.currentPage);
		},
		getTypeList(type) {
			this.$applicationJson('/business/base/diet/paging', {
				current: 0,
				orderBy: '',
				params: { name: '', type },
				size: 1000,
			})
				.then((res) => {
					if (res.data.code !== 0) return;
					if (type === '菜肴') this.dietDishListData = res.data.data.records;
					if (type === '粥食') this.porridgeListData = res.data.data.records;
					if (type === '汤羹') this.dietSugSoupData = res.data.data.records;
					if (type === '茶饮') this.dietSugTeaData = res.data.data.records;
				})
				.catch(() => this.$message.error('网络异常'));
		},
		getAcupointList() {
			this.$applicationJson('/business/base/acupoint/paging', {
				current: 0,
				orderBy: '',
				params: { name: '', type: '' },
				size: 100,
			})
				.then((res) => {
					if (res.data.code === 0) this.acupointListData = res.data.data.records;
				})
				.catch(() => this.$message.error('网络异常'));
		},
		getMedicinalFoodList() {
			this.$applicationJson('/business/base/medicinalFood/paging', {
				current: 0,
				orderBy: '',
				params: { name: '' },
				size: 100,
			})
				.then((res) => {
					if (res.data.code === 0) this.medicinalFoodListData = res.data.data.records;
				})
				.catch(() => this.$message.error('网络异常'));
		},
		getHealthFoodList() {
			this.$applicationJson('/business/base/healthFood/paging', {
				current: 0,
				orderBy: '',
				params: { name: '' },
				size: 100,
			})
				.then((res) => {
					if (res.data.code === 0) this.healthFoodListData = res.data.data.records;
				})
				.catch(() => this.$message.error('网络异常'));
		},
		getBjcExerciseList() {
			this.$applicationJson('/business/base/exercises/paging', {
				current: 0,
				orderBy: '',
				params: { name: '' },
				size: 200,
			})
				.then((res) => {
					if (res.data.code === 0) this.bjcExerciseListData = res.data.data.records;
				})
				.catch(() => this.$message.error('网络异常'));
		},
		getCtgfExerciseList() {
			this.$applicationJson('/business/base/traditional/exercises/paging', {
				current: 0,
				orderBy: '',
				params: { name: '' },
				size: 200,
			})
				.then((res) => {
					if (res.data.code === 0) this.ctgfExerciseListData = res.data.data.records;
				})
				.catch(() => this.$message.error('网络异常'));
		},
		getSportExerciseList() {
			this.$applicationJson('/business/base/sport/paging', {
				current: 0,
				orderBy: '',
				params: { name: '' },
				size: 200,
			})
				.then((res) => {
					if (res.data.code === 0) this.sportExerciseListData = res.data.data.records;
				})
				.catch(() => this.$message.error('网络异常'));
		},
		getPhysiqueList(currentPage) {
			this.$applicationJson('/business/base/physique/paging', {
				current: currentPage,
				orderBy: '',
				params: { name: '' },
				size: 100,
			})
				.then((res) => {
					if (res.data.code === 0) this.constitutionOptions = res.data.data.records;
				})
				.catch(() => this.$message.error('网络异常'));
		},

		// ---------- RecommendGroup 事件分发 ----------
		handleGroupSelect({ configKey, item, index }) {
			const list = this.addUserForm[configKey];
			if (!list || !list[index]) return;
			if (list[index].list.indexOf(item) === -1) {
				list[index].list.push(item);
			}
		},
		handleGroupDelete({ configKey, tag, index }) {
			const list = this.addUserForm[configKey];
			if (!list || !list[index]) return;
			const i = list[index].list.indexOf(tag);
			if (i !== -1) list[index].list.splice(i, 1);
		},
		handleTextFieldUpdate({ frontKey, value }) {
			this.addUserForm[frontKey] = value;
		},
	},

	created() {
		this.$nextTick(() => {
			const loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
			const role = loginInfo.role;
			this.role = role;
			if (role == 1) this.tabList.splice(0, 5);
			this.getPhysiqueList(0);
			this.getPlanList(0);
			this.getAcupointList();
			this.getTypeList('菜肴');
			this.getTypeList('粥食');
			this.getTypeList('汤羹');
			this.getTypeList('茶饮');
			this.getMedicinalFoodList();
			this.getHealthFoodList();
			this.getBjcExerciseList();
			this.getCtgfExerciseList();
			this.getSportExerciseList();
		});
	},
};
</script>

<style lang="less" scoped="scoped">
@import "../../../static/css/layout.less";
@import "../../../static/css/mentor.less";

.el-input { width: auto; }

.independent-wrapper {
	.content {
		height: calc(100% - 40px);
		.contentLeft {
			width: 100%;
			height: calc(100% - 40px);
			.con {
				min-height: calc(100% - 80px);
				.search-con {
					height: 60px;
					.demo-form-inline {
						margin-top: 10px;
						:deep(.el-input__inner) { width: 160px; }
					}
				}
			}
			.table-con {
				border: none;
				background: #fff;
				height: 100%;
				float: none;
				.editor { cursor: pointer; color: #679ff6; }
				.del { color: #df6d78; cursor: pointer; margin-left: 10px; }
			}
		}
	}
	.dialog {
		:deep(.el-dialog__body) {
			padding: 0;
			.con {
				margin-top: 30px;
				padding: 0 5px;
				width: calc(100% - 10px);
				overflow-y: auto;
				padding-bottom: 30px;
				min-height: 500px;
				.item {
					width: 100%;
					overflow: hidden;
					float: left;
					.line {
						width: 100%;
						overflow: hidden;
						margin-bottom: 30px;
						&:nth-child(1) { margin-bottom: 20px; }
						.dosageIcon {
							font-size: 16px;
							color: #666;
							margin-left: 10px;
							cursor: pointer;
						}
						.dialog-tit {
							height: 40px;
							line-height: 40px;
							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: calc(100% - 24px);
								color: #333;
								margin-left: 10px;
							}
							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								left: 0px;
							}
						}
						.food-con {
							width: 96%;
							margin-left: 2%;
							padding-bottom: 20px;
							float: left;
							.food-con-con {
								margin-left: 0px;
								float: left;
								width: 100%;
							}
							:deep(.el-input-group--append) { width: 100%; }
							:deep(.el-input__inner) { width: 100%; }
							.list {
								width: calc(100% - 62px);
								float: left;
								margin-bottom: 20px;
								overflow: hidden;
								border: 1px solid #eee;
								border-top: 0px;
								ul {
									width: 96%;
									margin: 10px 2%;
									float: left;
									overflow: hidden;
									li {
										width: 33.3%;
										float: left;
										line-height: 30px;
										cursor: pointer;
										height: 30px;
										span {
											float: left;
											&:nth-child(2) { margin: 0 10px 0 5px; }
										}
										i {
											line-height: 30px;
											color: red;
											margin-left: 5px;
											float: left;
											margin-top: 1px;
										}
									}
								}
							}
							.dietList {
								ul { li { width: 50%; } }
							}
							.margin0 {
								width: 100%;
								float: left;
								.el-form-item__content { margin-left: 0px !important; }
								:deep(.el-form-item__content) { margin-left: 0px !important; }
							}
							.el-form-item { width: 100%; float: left; }
						}
					}
				}
				.el-form-item { width: 100% !important; float: left; }
				.longInput {
					width: calc(100% - 40px);
					:deep(.el-input__inner) { width: 100% !important; }
				}
				.smallInput {
					width: 150px;
					:deep(.el-input__inner) { width: 100%; }
				}
			}
		}
	}
}
</style>

<style lang="less">
/* RecommendGroup 共享 dialog 内的 .line / .food-con 样式（scoped 样式无法穿透到子组件根元素之外，故部分关键 class 用全局补） */
.el-dialog__body .line .food-con .list ul li i {
	cursor: pointer;
}
</style>
